import styled from '@emotion/styled'
import React, { useEffect } from 'react'
import { Platform } from '@/firebase/firestore/Platform'
import fitty from 'fitty'

type Props = {
  targetId: string
  templateColor: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7
  uid: string
  name: string
  platform: Array<Platform>
  voiceChat: Array<0 | 1 | 2 | 3 | 4 | 5>
  playStyle: string
  fontFamily: string
  fontColor: string
  hitokoto: string
  dbdSurvivor: number[]
  dbdKiller: number[]
}

export const DBD2: React.FC<Props> = ({
  targetId,
  uid,
  name,
  templateColor,
  playStyle,
  platform,
  voiceChat,
  hitokoto,
  dbdSurvivor,
  dbdKiller,
  fontFamily,
  fontColor,
}) => {
  useEffect(() => {
    fitty('#name', {
      maxSize: 18,
      minSize: 12,
    })
    fitty('#uid', {
      maxSize: 15,
      minSize: 8,
    })
    fitty('#platform', {
      maxSize: 15,
      minSize: 8,
    })
    fitty('#voiceChat', {
      maxSize: 15,
      minSize: 8,
    })
    fitty('#playStyle', {
      maxSize: 13,
      minSize: 8,
    })
    fitty('#hitokoto', {
      maxSize: 22,
      minSize: 12,
    })
  }, [])
  return (
    <ProfileContainer>
      <ProfileInner id={targetId} fontFamily={fontFamily} color={fontColor}>
        {/* To avoid cors err */}
        <img
          width="1368"
          height="2048"
          src={`/static/images/profiles/dbd2/${templateColor}.jpeg`}
        />
        <Name>
          <span id="name">{name}</span>
        </Name>
        <Id>
          <span id="uid">{uid}</span>
        </Id>
        <PlatformText>
          <span id="platform">
            {platform.includes(0) && ' PC '}
            {platform.includes(1) && ' プレステ '}
            {platform.includes(2) && ' Xbox '}
            {platform.includes(3) && ' Switch '}
            {platform.includes(4) && ' モバイル '}
          </span>
        </PlatformText>
        <PlayStyle>
          <span id="playStyle">{playStyle}</span>
        </PlayStyle>
        <Hitokoto>
          <span id="hitokoto">{hitokoto}</span>
        </Hitokoto>
        <VCText color={fontColor}>
          <span id="voiceChat">
            {voiceChat.includes(0) && ' Skype '}
            {voiceChat.includes(1) && ' LINE '}
            {voiceChat.includes(2) && ' プレステ '}
            {voiceChat.includes(3) && ' Discord '}
            {voiceChat.includes(4) && ' 聞き専 '}
            {voiceChat.includes(5) && ' Switch '}
          </span>
        </VCText>
        {dbdKiller.includes(0) && <Killer0 color={fontColor} />}
        {dbdKiller.includes(1) && <Killer1 color={fontColor} />}
        {dbdKiller.includes(2) && <Killer2 color={fontColor} />}
        {dbdKiller.includes(3) && <Killer3 color={fontColor} />}
        {dbdKiller.includes(4) && <Killer4 color={fontColor} />}
        {dbdKiller.includes(5) && <Killer5 color={fontColor} />}
        {dbdKiller.includes(6) && <Killer6 color={fontColor} />}
        {dbdKiller.includes(7) && <Killer7 color={fontColor} />}
        {dbdKiller.includes(8) && <Killer8 color={fontColor} />}
        {dbdKiller.includes(9) && <Killer9 color={fontColor} />}
        {dbdKiller.includes(10) && <Killer10 color={fontColor} />}
        {dbdKiller.includes(11) && <Killer11 color={fontColor} />}
        {dbdKiller.includes(12) && <Killer12 color={fontColor} />}
        {dbdKiller.includes(13) && <Killer13 color={fontColor} />}
        {dbdKiller.includes(14) && <Killer14 color={fontColor} />}
        {dbdKiller.includes(15) && <Killer15 color={fontColor} />}
        {dbdKiller.includes(16) && <Killer16 color={fontColor} />}
        {dbdKiller.includes(17) && <Killer17 color={fontColor} />}
        {dbdKiller.includes(18) && <Killer18 color={fontColor} />}
        {dbdKiller.includes(19) && <Killer19 color={fontColor} />}
        {dbdKiller.includes(20) && <Killer20 color={fontColor} />}
        {dbdKiller.includes(21) && <Killer21 color={fontColor} />}
        {dbdKiller.includes(22) && <Killer22 color={fontColor} />}
        {dbdKiller.includes(23) && <Killer23 color={fontColor} />}
        {dbdKiller.includes(24) && <Killer24 color={fontColor} />}
        {dbdKiller.includes(25) && <Killer25 color={fontColor} />}
        {dbdKiller.includes(26) && <Killer26 color={fontColor} />}
        {dbdKiller.includes(27) && <Killer27 color={fontColor} />}
        {dbdKiller.includes(28) && <Killer28 color={fontColor} />}
        {dbdKiller.includes(29) && <Killer29 color={fontColor} />}
        {dbdKiller.includes(30) && <Killer30 color={fontColor} />}
        {dbdKiller.includes(31) && <Killer31 color={fontColor} />}
        {dbdKiller.includes(32) && <Killer32 color={fontColor} />}
        {dbdKiller.includes(33) && <Killer33 color={fontColor} />}
        {dbdSurvivor.includes(0) && <Survivor0 color={fontColor} />}
        {dbdSurvivor.includes(1) && <Survivor1 color={fontColor} />}
        {dbdSurvivor.includes(2) && <Survivor2 color={fontColor} />}
        {dbdSurvivor.includes(3) && <Survivor3 color={fontColor} />}
        {dbdSurvivor.includes(4) && <Survivor4 color={fontColor} />}
        {dbdSurvivor.includes(5) && <Survivor5 color={fontColor} />}
        {dbdSurvivor.includes(6) && <Survivor6 color={fontColor} />}
        {dbdSurvivor.includes(7) && <Survivor7 color={fontColor} />}
        {dbdSurvivor.includes(8) && <Survivor8 color={fontColor} />}
        {dbdSurvivor.includes(9) && <Survivor9 color={fontColor} />}
        {dbdSurvivor.includes(10) && <Survivor10 color={fontColor} />}
        {dbdSurvivor.includes(11) && <Survivor11 color={fontColor} />}
        {dbdSurvivor.includes(12) && <Survivor12 color={fontColor} />}
        {dbdSurvivor.includes(13) && <Survivor13 color={fontColor} />}
        {dbdSurvivor.includes(14) && <Survivor14 color={fontColor} />}
        {dbdSurvivor.includes(15) && <Survivor15 color={fontColor} />}
        {dbdSurvivor.includes(16) && <Survivor16 color={fontColor} />}
        {dbdSurvivor.includes(17) && <Survivor17 color={fontColor} />}
        {dbdSurvivor.includes(18) && <Survivor18 color={fontColor} />}
        {dbdSurvivor.includes(19) && <Survivor19 color={fontColor} />}
        {dbdSurvivor.includes(20) && <Survivor20 color={fontColor} />}
        {dbdSurvivor.includes(21) && <Survivor21 color={fontColor} />}
        {dbdSurvivor.includes(22) && <Survivor22 color={fontColor} />}
        {dbdSurvivor.includes(23) && <Survivor23 color={fontColor} />}
        {dbdSurvivor.includes(24) && <Survivor24 color={fontColor} />}
        {dbdSurvivor.includes(25) && <Survivor25 color={fontColor} />}
        {dbdSurvivor.includes(26) && <Survivor26 color={fontColor} />}
        {dbdSurvivor.includes(27) && <Survivor27 color={fontColor} />}
        {dbdSurvivor.includes(28) && <Survivor28 color={fontColor} />}
        {dbdSurvivor.includes(29) && <Survivor29 color={fontColor} />}
        {dbdSurvivor.includes(30) && <Survivor30 color={fontColor} />}
        {dbdSurvivor.includes(31) && <Survivor31 color={fontColor} />}
        {dbdSurvivor.includes(32) && <Survivor32 color={fontColor} />}
        {dbdSurvivor.includes(33) && <Survivor33 color={fontColor} />}
        {dbdSurvivor.includes(34) && <Survivor34 color={fontColor} />}
        {dbdSurvivor.includes(35) && <Survivor35 color={fontColor} />}
        {dbdSurvivor.includes(36) && <Survivor36 color={fontColor} />}
        {dbdSurvivor.includes(37) && <Survivor37 color={fontColor} />}
        {dbdSurvivor.includes(38) && <Survivor38 color={fontColor} />}
      </ProfileInner>
    </ProfileContainer>
  )
}

const ProfileContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #4c4c4c;
`

const ProfileInner = styled.div<{ fontFamily: string; color: string }>`
  position: relative;
  line-height: 0;
  width: 220px;
  * {
    line-height: 1;
    font-family: ${({ fontFamily }) => fontFamily};
    color: ${({ color }) => color};
  }
`

const Name = styled.div`
  position: absolute;
  top: 15.5%;
  left: 3%;
  width: 28%;
  height: 14%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    letter-spacing: -1px;
    font-weight: bold;
  }
`

const Id = styled.div`
  position: absolute;
  top: 27%;
  left: 3%;
  width: 28%;
  height: 14%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    letter-spacing: -1px;
    font-weight: bold;
  }
`

const PlatformText = styled.div`
  position: absolute;
  top: 39%;
  left: 2%;
  width: 28%;
  height: 14%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    letter-spacing: -1px;
    font-weight: bold;
  }
`

const PlayStyle = styled.span`
  position: absolute;
  top: 76.5%;
  left: 53%;
  width: 44%;
  height: 4%;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    font-weight: bold;
    line-height: 7px;
  }
`

const VCText = styled.div`
  position: absolute;
  top: 49%;
  left: 3%;
  width: 28%;
  height: 14%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    letter-spacing: -1px;
    font-weight: bold;
  }
`

const SurvivorBase = styled.div<{ color: string }>`
  position: absolute;
  top: 6.5%;
  left: 36.2%;
  border-style: solid;
  border-color: ${({ color }) => color};
  border-width: 3px;
  border-radius: 50%;
  width: 24px;
  height: 24px;
`

const Survivor0 = styled(SurvivorBase)`
  left: 31%;
`
const Survivor1 = styled(SurvivorBase)`
  left: 41.5%;
`
const Survivor2 = styled(SurvivorBase)`
  left: 53%;
`
const Survivor3 = styled(SurvivorBase)`
  left: 64%;
`
const Survivor4 = styled(SurvivorBase)`
  left: 75%;
`
const Survivor5 = styled(SurvivorBase)`
  left: 86.5%;
`

//2段目
const Survivor6 = styled(SurvivorBase)`
  top: 13.5%;
  left: 31%;
`

const Survivor7 = styled(SurvivorBase)`
  top: 13.5%;
  left: 41.5%;
`

const Survivor8 = styled(SurvivorBase)`
  top: 13.5%;
  left: 53%;
`

const Survivor9 = styled(SurvivorBase)`
  top: 13.5%;
  left: 64%;
`

const Survivor10 = styled(SurvivorBase)`
  top: 13.5%;
  left: 75%;
`

const Survivor11 = styled(SurvivorBase)`
  top: 13.5%;
  left: 86.5%;
`

//3段目
const Survivor12 = styled(SurvivorBase)`
  top: 20.5%;
  left: 31%;
`

const Survivor13 = styled(SurvivorBase)`
  top: 20.5%;
  left: 41.5%;
`
const Survivor14 = styled(SurvivorBase)`
  top: 20.5%;
  left: 53%;
`

const Survivor15 = styled(SurvivorBase)`
  top: 20.5%;
  left: 64%;
`

const Survivor16 = styled(SurvivorBase)`
  top: 20.5%;
  left: 75%;
`

const Survivor17 = styled(SurvivorBase)`
  top: 20.5%;
  left: 86.5%;
`

//4段目
const Survivor18 = styled(SurvivorBase)`
  top: 27.5%;
  left: 31%;
`

const Survivor19 = styled(SurvivorBase)`
  top: 27.5%;
  left: 41.5%;
`

const Survivor20 = styled(SurvivorBase)`
  top: 27.5%;
  left: 53%;
`

const Survivor21 = styled(SurvivorBase)`
  top: 27.5%;
  left: 64%;
`

const Survivor22 = styled(SurvivorBase)`
  top: 27.5%;
  left: 75%;
`

const Survivor23 = styled(SurvivorBase)`
  top: 27.5%;
  left: 86.5%;
`

//5段目
const Survivor24 = styled(SurvivorBase)`
  top: 34.5%;
  left: 31%;
`
const Survivor25 = styled(SurvivorBase)`
  top: 34.5%;
  left: 41.5%;
`
const Survivor26 = styled(SurvivorBase)`
  top: 34.5%;
  left: 53%;
`

const Survivor27 = styled(SurvivorBase)`
  top: 34.5%;
  left: 64%;
`

const Survivor28 = styled(SurvivorBase)`
  top: 34.5%;
  left: 75%;
`

const Survivor29 = styled(SurvivorBase)`
  top: 34.5%;
  left: 86.5%;
`

//6段目
const Survivor30 = styled(SurvivorBase)`
  top: 41.5%;
  left: 31%;
`

const Survivor31 = styled(SurvivorBase)`
  top: 41.5%;
  left: 41.5%;
`

const Survivor32 = styled(SurvivorBase)`
  top: 41.5%;
  left: 53%;
`

const Survivor33 = styled(SurvivorBase)`
  top: 41.5%;
  left: 64%;
`

const Survivor34 = styled(SurvivorBase)`
  top: 41.5%;
  left: 75%;
`

const Survivor35 = styled(SurvivorBase)`
  top: 41.5%;
  left: 86.5%;
`

const Survivor36 = styled(SurvivorBase)`
  top: 48%;
  left: 31%;
`

const Survivor37 = styled(SurvivorBase)`
  top: 48%;
  left: 41.5%;
`

const Survivor38 = styled(SurvivorBase)`
  top: 48%;
  left: 53%;
`

const KillerBase = styled.div<{ color: string }>`
  position: absolute;
  top: 56.5%;
  left: 36.2%;
  border-style: solid;
  border-color: ${({ color }) => color};
  border-width: 3px;
  border-radius: 50%;
  width: 24px;
  height: 24px;
`
const Killer0 = styled(KillerBase)`
  left: 31%;
`
const Killer1 = styled(KillerBase)`
  left: 41.5%;
`
const Killer2 = styled(KillerBase)`
  left: 53%;
`
const Killer3 = styled(KillerBase)`
  left: 64%;
`
const Killer4 = styled(KillerBase)`
  left: 75%;
`
const Killer5 = styled(KillerBase)`
  left: 86.5%;
`
const Killer6 = styled(KillerBase)`
  top: 63%;
  left: 31%;
`
const Killer7 = styled(KillerBase)`
  top: 63%;
  left: 41.5%;
`
const Killer8 = styled(KillerBase)`
  top: 63%;
  left: 53%;
`
const Killer9 = styled(KillerBase)`
  top: 63%;
  left: 64%;
`
const Killer10 = styled(KillerBase)`
  top: 63%;
  left: 75%;
`
const Killer11 = styled(KillerBase)`
  top: 63%;
  left: 86.5%;
`
const Killer12 = styled(KillerBase)`
  top: 70.5%;
  left: 31%;
`
const Killer13 = styled(KillerBase)`
  top: 70.5%;
  left: 41.5%;
`

const Killer14 = styled(KillerBase)`
  top: 70.5%;
  left: 53%;
`
const Killer15 = styled(KillerBase)`
  top: 70.5%;
  left: 64%;
`
const Killer16 = styled(KillerBase)`
  top: 70.5%;
  left: 75%;
`
const Killer17 = styled(KillerBase)`
  top: 70.5%;
  left: 86.5%;
`
const Killer18 = styled(KillerBase)`
  top: 77.5%;
  left: 31%;
`
const Killer19 = styled(KillerBase)`
  top: 77.5%;
  left: 41.5%;
`
const Killer20 = styled(KillerBase)`
  top: 77.5%;
  left: 53%;
`
const Killer21 = styled(KillerBase)`
  top: 77.5%;
  left: 64%;
`
const Killer22 = styled(KillerBase)`
  top: 77.5%;
  left: 75%;
`

const Killer23 = styled(KillerBase)`
  top: 77.5%;
  left: 86.5%;
`

const Killer24 = styled(KillerBase)`
  top: 84.5%;
  left: 31%;
`

const Killer25 = styled(KillerBase)`
  top: 84.5%;
  left: 41.5%;
`

const Killer26 = styled(KillerBase)`
  top: 84.5%;
  left: 53%;
`

const Killer27 = styled(KillerBase)`
  top: 84.5%;
  left: 64%;
`

const Killer28 = styled(KillerBase)`
  top: 84.5%;
  left: 75%;
`

const Killer29 = styled(KillerBase)`
  top: 84.5%;
  left: 86.5%;
`

const Killer30 = styled(KillerBase)`
  top: 91%;
  left: 31%;
`

const Killer31 = styled(KillerBase)`
  top: 91%;
  left: 41.5%;
`
const Killer32 = styled(KillerBase)`
  top: 91%;
  left: 53%;
`

const Killer33 = styled(KillerBase)`
  top: 91%;
  left: 64%;
`

const Hitokoto = styled.div`
  position: absolute;
  top: 65%;
  left: 3%;
  width: 28%;
  height: 30%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    letter-spacing: -1px;
    line-height: 13px;
    font-weight: bold;
  }
`
